<template>
  <div class="withdrawalDialog">
    <el-dialog title="申请提现" :visible.sync="isShow" width="750px" append-to-body :before-close="resetForm">
      <el-form class="withdrawalDialog" label-width="100px" :model="editNoticeData" ref="withdrawal" :rules="rules" :inline="false">
        <el-form-item label="提现方式：">
          <el-select v-model="editNoticeData.state" style="width:100%;" disabled>
            <el-option v-for="item in areTypeState" :key="item.key" :label="item.value" :value="item.key"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="到账账户：">
          <el-button v-if="noWxUser" type="primary" size="mini" @click="wxUserBindingState = true">绑定微信</el-button>
          <div v-else class="wxUserBox">
            <img class="avatar" :src="editNoticeData.avatar" alt="">
            <span class="nickName">{{editNoticeData.nickName}}</span>
            <el-button type="primary" size="mini" @click="wxUserBindingState = true">更改微信</el-button>
          </div>
        </el-form-item>
        <el-form-item label="提现金额：" prop="amount">
          <el-input v-model="editNoticeData.amount" maxlength="5" placeholder="请输入提现金额" clearable></el-input>
          <p>单次最低提现为1元</p>
        </el-form-item>
        <el-form-item label="手机号：">
          <span>{{editNoticeData.mobile}}</span>
          <el-button type="primary" size="mini" class="codeBox" v-if="editNoticeData.mobile" :disabled="codeGetState" @click="getCode">{{codeGetState ? `${codeTime}秒后可重新获取` : '获取验证码'}}</el-button>
        </el-form-item>
        <el-form-item label="验证码：" prop="code">
          <el-input v-model="editNoticeData.code" placeholder="请输入验证码" clearable></el-input>
          <div>
            由于微信支付限制，一个商户同一天提现总额限额19,999<br />
            提现申请需要1个工作日内审核，审核通过后将发起微信打款，总计1-3个工作日到账，周末节假日顺延，请以实际到账时间为
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="danger" @click="resetForm()" style="width:100px;">取消</el-button>
          <el-button type="primary" @click="onSubmitHandler" style="width:100px;">提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <wxUserBinding v-if="wxUserBindingState" :id="editNoticeData.sponsorId" @cancelEvent="wxUserBindingState = false" @binding="binding"></wxUserBinding>
  </div>
</template>

<script>
import { setInterval, clearInterval, setTimeout } from 'timers';
import property from '@/services/finance/property'
import wxUserBinding from './wxUserBinding'
import { mapActions } from 'vuex';
export default {
  props: {
    moneyNum: {
      type: Number,
      default: () => {
        return ''
      }
    }
  },
  data () {
    return {
      isShow: false,
      editNoticeData: {
        state: 0,
        amount: null,
        code: null,
        mobile: null,
        sponsorId: null,
        nickName: null,
        avatar: null
      },
      codeGetState: false,
      codeTime: 60,
      timeClear: null,
      noWxUser: true,
      wxUserBindingState: false,
      areTypeState: [{
        key: 0,
        value: '微信提现'
      }],
      rules: {
        amount: [
          { required: true, message: '请输入现金数值', trigger: 'blur' },
          { pattern: /^(?!0+(?:\.0+)?$)(?:[1-9]\d*|0)(?:\.\d{1,2})?$/, message: '请输入正确的现金数值', trigger: 'blur' },
          { pattern: /^([1][0-9]{4})$|^([1-9]([0-9]{0,3}))$/, message: '提现金额为1-19,999', trigger: 'blur' }
        ],
        code: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
      }
    }
  },
  components: {
    wxUserBinding
  },
  created() {
    this.openModal()
  },
  methods: {
    ...mapActions(['changWithdrawalState']),
    async openModal () {
      this.changWithdrawalState(false)
      const { code, result, params } = await property.accountInfo();
      if (code === 0) {
        const { sponsorId, mobile, avatar, nickName } = result
        this.editNoticeData = {
          ...this.editNoticeData,
          sponsorId, mobile, avatar, nickName
        }
        this.noWxUser = false;
      } else if (code === 1024) {
        this.editNoticeData = {
          ...this.editNoticeData,
          ...params,
        }
        this.noWxUser = true;
      }
      this.isShow = true;
    },
    onSubmitHandler () {
      this.$refs['withdrawal'].validate((valid) => {
        if (!valid) return false;
        if (this.editNoticeData.amount > this.moneyNum) {
          this.$message.error(`您本次申请提现金额大于可提现金额${this.moneyNum}元`)
          return false;
        }
        if (this.noWxUser) {
          this.$message.error('请绑定到账微信账户')
          return false;
        }
        this.$emit('withdrawalDialogBtn', this.editNoticeData, this.moneyNum)
      })
    },
    resetForm () {
      this.isShow = false
      setTimeout(()=> {this.$emit('closeDialog')}, 500)
    },
    getCode () {
      property.getCode({ mobile: this.editNoticeData.mobile }).then(res => {
        if (res.code === 0) {
          this.$message.success('发送成功')
          this.changWithdrawalState(true)
          this.codeGetState = true;
          this.time()
        }
      })
    },
    time () {
      this.timeClear = setInterval(() => {
        if (this.codeTime <= 0) {
          this.codeGetState = false;
          clearInterval(this.timeClear)
          return false;
        }
        this.codeTime--;
      }, 1000)
    },
    binding() {
      this.wxUserBindingState = false;
      this.openModal()
    }
  }
}
</script>

<style lang="scss" scoped>
.codeBox {
  margin-left: 20px;
}
.wxUserBox {
  line-height: 50px;
  overflow: hidden;
  img.avatar {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    margin-right: 20px;
    float: left;
  }
  .nickName {
    float: left;
    margin-right: 20px
  }
}
</style>
